import {Component, OnInit} from '@angular/core';
declare var tinymce: any;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {


    title = 'Planmob';

    ngOnInit(): void {
        /**
         *  Atributo adicionado para fazer os imports corretos de assets do TinyMCE.
         *  que estão referenciados no arquivo angular.json
         */
        tinymce.baseURL = '/tinymce';
    }
}
